import React, { FunctionComponent } from 'react';
import ProductComponent, {
  TParentComponentProps,
} from '@views/components/common/ParentComponent';

export const Wrapper: FunctionComponent<TParentComponentProps> = ({
  ...otherProps
}) => <ProductComponent {...otherProps} />;
Wrapper.defaultProps = {
  defaultClassName: 'breadcrumb-wrapper',
};

export default Wrapper;
